import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ExternalLink } from 'lucide-react';
import { ReferralData } from '../types';

interface ReferralsWidgetProps {
  timePeriod?: string;
  websites: ReferralData[];
  keywords: ReferralData[];
}

const ReferralsWidget: React.FC<ReferralsWidgetProps> = ({ 
  timePeriod = '7d',
  websites,
  keywords
}) => {
  console.log("websites", websites);
  return (
    <Card className="w-full">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2 px-0">
        <CardTitle className="text-sm font-medium">Referrals</CardTitle>
        <ExternalLink className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent className="px-0">
        <div className="space-y-4">
          {/* Websites Section */}
          <div className="space-y-2">
            <h4 className="text-xs font-medium text-muted-foreground">Websites</h4>
            {websites.map((website, index) => (
              <div key={website.source} className="group relative px-0">
                <div className="relative flex items-center justify-between p-2 rounded-lg overflow-hidden">
                  {/* Background Progress Bar */}
                  <div 
                    className="absolute inset-0 bg-primary/10 transition-all duration-300 ease-out"
                    style={{ width: `${website.percentage}%` }}
                  ></div>
                  
                  {/* Content on top of progress bar */}
                  <div className="relative flex items-center space-x-3 flex-1">
                    <div className="flex flex-row relative">
                      <span className="text-sm text-muted-foreground opacity-100 group-hover:opacity-30 transition-opacity duration-200">
                        {website.source.length > 20 
                          ? `${website.source.substring(0, 10)}...${website.source.substring(website.source.length - 7)}`
                          : website.source
                        }
                      </span>
                    </div>
                  </div>
                </div>
                <div className="absolute text-right top-0  opacity-0 group-hover:opacity-100 right-0 h-full w-full text-muted-foreground bg-background/30 duration-200 rounded px-2 py-1">
                  <span className="text-sm font-semibold text-foreground">
                    {website.percentage.toFixed(1)}%
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ReferralsWidget;
